var CREATE_EXPERIENCE = /* @__PURE__ */ ((CREATE_EXPERIENCE2) => {
  CREATE_EXPERIENCE2["metricWizard"] = "MetricWizard";
  CREATE_EXPERIENCE2["rawMode"] = "RawMode";
  return CREATE_EXPERIENCE2;
})(CREATE_EXPERIENCE || {});
var AGGREGATION_TYPE = /* @__PURE__ */ ((AGGREGATION_TYPE2) => {
  AGGREGATION_TYPE2["average"] = "Average";
  AGGREGATION_TYPE2["weightedAverage"] = "Weighted Average";
  AGGREGATION_TYPE2["percentile"] = "Percentile";
  return AGGREGATION_TYPE2;
})(AGGREGATION_TYPE || {});
var METRIC_FUNCTION = /* @__PURE__ */ ((METRIC_FUNCTION2) => {
  METRIC_FUNCTION2["count"] = "COUNT";
  METRIC_FUNCTION2["countDistinct"] = "COUNTDISTINCT";
  METRIC_FUNCTION2["max"] = "MAX";
  METRIC_FUNCTION2["min"] = "MIN";
  METRIC_FUNCTION2["sum"] = "SUM";
  METRIC_FUNCTION2["average"] = "Average";
  METRIC_FUNCTION2["rate"] = "Rate";
  METRIC_FUNCTION2["indicator"] = "Indicator";
  METRIC_FUNCTION2["ratio"] = "Ratio";
  return METRIC_FUNCTION2;
})(METRIC_FUNCTION || {});
var COLUMN_FILTER_OPTIONS = /* @__PURE__ */ ((COLUMN_FILTER_OPTIONS2) => {
  COLUMN_FILTER_OPTIONS2["column"] = "column";
  COLUMN_FILTER_OPTIONS2["none"] = "none";
  return COLUMN_FILTER_OPTIONS2;
})(COLUMN_FILTER_OPTIONS || {});
var FILL_OPTION = /* @__PURE__ */ ((FILL_OPTION2) => {
  FILL_OPTION2["zero"] = "0";
  FILL_OPTION2["null"] = "null";
  return FILL_OPTION2;
})(FILL_OPTION || {});
var THRESHOLD_OPERATOR = /* @__PURE__ */ ((THRESHOLD_OPERATOR2) => {
  THRESHOLD_OPERATOR2["greaterThan"] = ">";
  THRESHOLD_OPERATOR2["lessThan"] = "<";
  return THRESHOLD_OPERATOR2;
})(THRESHOLD_OPERATOR || {});
export {
  AGGREGATION_TYPE,
  COLUMN_FILTER_OPTIONS,
  CREATE_EXPERIENCE,
  FILL_OPTION,
  METRIC_FUNCTION,
  THRESHOLD_OPERATOR
};
//# sourceMappingURL=MetricDefinitionUIModel.js.map
